import axios from "@/api/axiosInstance";
import type {
  CreatePaymentSourceRequest,
  CreatePaymentSourceResponse,
} from "./types";

export const createPaymentSource = async (
  request: CreatePaymentSourceRequest,
): Promise<CreatePaymentSourceResponse> => {
  const response = await axios.post<CreatePaymentSourceResponse>(
    "/api/private/payment-sources",
    request,
  );
  return response.data;
};
